const CheckIcon = (color?: string): JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM8 14.9996L3 9.99961L4.4 8.59961L8 12.1996L15.6 4.59961L17 5.99961L8 14.9996Z"
      fill={color}
    />
  </svg>
);

CheckIcon.defaultProps = {
  color: '#E1E1E8',
};

export default CheckIcon;
